export default __webpack_public_path__ + "static/media/regulatory--truck-speed-limit-25--g1.96be34eb.png";